import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import moment from 'moment';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';

import Status from '../../../Common/Status';
import { buildInvoiceItemDescription } from '../../../../utils/helper';

import styles from '../BillingView/styles';
import { CONFIRM_DIALOG, CREDIT_CARD_DIALOG, UPGRADE_DIALOG } from '../../../../redux/constants/dialogs';
import Grid from '../../../Common/Grid';

const COLUMNS = [
  { name: 'from', title: 'From' },
  { name: 'to', title: 'To' },
  { name: 'description', title: 'Description' },
  // { name: 'accounts', title: 'Accounts' },
  { name: 'tasks', title: 'Tasks' },
  { name: 'taskCost', title: 'Task Cost' },
  { name: 'amount', title: 'Amount' },
  { name: 'paid', title: 'Status' },
];

const COLUMN_EXTENSIONS = [
  // { columnName: '', width: 100 },
];

const getCellComponent = () => ({ row, column, value }) => {
  switch (column.name) {
    case 'from':
      return moment(row.period.start).format('ll');
    case 'to':
      return moment(row.period.end).format('ll');
    case 'description':
      return row.lines.map((line) => <div
        key={line.id}>{buildInvoiceItemDescription(line)}</div>);
    case 'accounts':
      return value || 1;
    case 'taskCost':
      return Number(value).toFixed(2);
    case 'amount':
      return `$${value.toFixed(2)}`;
    case 'paid':
      return value ? <Status label="Paid" containerStyle={styles.paid}/> :
        <Status label="Outstanding" containerStyle={styles.outstanding}/>;
    default :
      return value;
  }
};

class BillingGrid extends Component {

  handleDownload = (invoice) => {
    alert('Not supported');
  };

  handleUpgrade = () => {
    this.props.showDialog(UPGRADE_DIALOG);
  };

  handleChangePaymentSource = () => {
    this.props.showDialog(CREDIT_CARD_DIALOG, {
      onRequestClose: ({ token }) => {
        // console.log('token', token);
        this.props.updatePaymentSource({ token });
      },
    });
  };

  handleCancelAccount = () => {
    console.log('handleCancelAccount');
    const context = {
      type: 'severe',
      title: 'Cancel Account?',
      message: 'All access will be removed and your data will be deleted. Are you sure you wish to cancel your account?',
      buttons: [
        <Button
          variant="text"
          onClick={() => this.props.hideDialog(CONFIRM_DIALOG)}
        >Cancel</Button>,
        <Button
          variant="text"
          onClick={() => {
            this.props.hideDialog(CONFIRM_DIALOG);
            this.props.cancelAccount();
          }}
        >Remove</Button>,
      ],
    };

    this.props.showDialog(CONFIRM_DIALOG, context);
  };

  render() {
    const { data, fetch } = this.props;
    return (<Grid
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent()}
      data={data}
      fetch={fetch}
      noDataCellComponent={getNoDataCellComponent(<MonetizationOnIcon style={styles.noData}/>, 'invoices')}
    />);
  }
}

BillingGrid.propTypes = {
  fetch: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default BillingGrid;



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingGrid/index.js